import { useEffect, useState } from "react";
import Notification from "../../../../components/toast";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { schema } from "./schema";

// Bancos com layout CNAB implementado no ACBr e testado aqui.
// Adicionar um novo aqui nao exige mudar codigo do servidor: o ACBr
// resolve o layout pelo codigo Febraban.
// O SelectInput usa a prop "id" como NOME DO CAMPO no formulario
// (<Controller name={id}>) e tambem como chave do valor em cada
// item do data (option[id]). Por isso cada lista abaixo usa a chave
// com o nome do proprio campo - se todas usassem "id", os selects
// escreveriam no mesmo campo e um apagaria o outro.
export const BANCOS = [
	{ banco: 1, nome: "001 - Banco do Brasil" },
	{ banco: 756, nome: "756 - Sicoob" },
	{ banco: 748, nome: "748 - Sicredi" },
	{ banco: 341, nome: "341 - Itau" },
	{ banco: 33, nome: "033 - Santander" },
	{ banco: 237, nome: "237 - Bradesco" },
	{ banco: 104, nome: "104 - Caixa" },
];

export const LAYOUTS = [
	{ layout: 400, nome: "CNAB 400" },
	{ layout: 240, nome: "CNAB 240" },
];

export const EMISSORES = [
	{ respon_emissao: "CLIENTE", nome: "Eu emito o boleto" },
	{ respon_emissao: "BANCO", nome: "O banco emite" },
];

export const AMBIENTES = [
	{ ambiente: "TESTE", nome: "Teste" },
	{ ambiente: "PRODUCAO", nome: "Producao" },
];

export const IndexHook = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		reset,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		resolver: zodResolver(schema),
		defaultValues: {
			id_boleto_config: 0,
			banco: 0,
			descricao: "",
			cedente_nome: "",
			cedente_cnpj: "",
			agencia: "",
			agencia_dv: "",
			conta: "",
			conta_dv: "",
			convenio: "",
			codigo_cedente: "",
			carteira: "",
			modalidade: "",
			especie_doc: "DM",
			layout: 400,
			respon_emissao: "CLIENTE",
			nosso_numero_ini: 1,
			nosso_numero_fim: 0,
			ambiente: "TESTE",
			ativo: true,
		},
	});

	const [loading, setLoading] = useState(false);

	const handleCloseModalRegister = () => {
		const event = new CustomEvent(`${ident}`);

		window.dispatchEvent(event);
	};

	useEffect(() => {
		if (isOpenModalRegister) {
			const id =
				typeof selectedData[idTable] === "number" && !isNaN(selectedData[idTable]) ? selectedData[idTable] : 0;

			if (id > 0) {
				fetch(id);
			}
		} else {
			if (setSelectData) setSelectData({});

			reset();
		}
	}, [isOpenModalRegister, selectedData]);

	const fetch = async (id) => {
		try {
			setLoading(true);

			const response = await fetchID(id);

			if (response.data && typeof response.data === "object") {
				Object.keys(response.data).forEach((field) => {
					setValue(field, response.data[field]);
				});
			}
		} catch (error) {
			Notification.showToast({ message: error.message, type: "warning" });
		} finally {
			setLoading(false);
		}
	};

	const getReturnUpdated = (response) => {
		if (Array.isArray(response.data)) {
			return response.data[0];
		} else if (typeof response.data === "object") {
			return response.data;
		} else {
			throw new Error("Formato do retorno inválido.");
		}
	};

	const handleOnSubmit = async (data) => {
		try {
			// ATIVO aqui e BOOLEAN no banco, diferente dos outros
			// cadastros que usam 'SIM'/'NAO'. Nao converter.
			const response = await insert(data);

			const returnUpdated = getReturnUpdated(response);
			const currentId = returnUpdated[idTable];

			await reloadData(data[idTable], currentId);

			Notification.showToast({ message: "Registro salvo com sucesso.", type: "success" });
			reset();
			handleCloseModalRegister();
		} catch (error) {
			Notification.showToast({ message: error.message, type: "error" });
		}
	};

	return {
		handleOnSubmit,
		handleCloseModalRegister,

		register,
		handleSubmit,
		setValue,
		control,
		setFocus,
		loading,

		errors,
		isSubmitting,
	};
};
